export const zoneConstants = {
  API_INSERT: '/api/site/location/zone/insert',
  API_UPDATE: '/api/site/location/zone/update',
  API_DELETE: '/api/site/location/zone/delete',
  API_GETALL: '/api/site/location/zone/',
  API_GETALL: '/api/site/location/zone/getall',

  INSERT_REQUEST: 'ZONE_INSERT_REQUEST',
  INSERT_SUCCESS: 'ZONE_INSERT_SUCCESS',
  INSERT_FAILURE: 'ZONE_INSERT_FAILURE',

  UPDATE_REQUEST: 'ZONE_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ZONE_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ZONE_UPDATE_FAILURE',

  DELETE_REQUEST: 'ZONE_DELETE_REQUEST',
  DELETE_SUCCESS: 'ZONE_DELETE_SUCCESS',
  DELETE_FAILURE: 'ZONE_DELETE_FAILURE',

  GET_REQUEST: 'ZONE_GET_REQUEST',
  GET_SUCCESS: 'ZONE_GET_SUCCESS',
  GET_FAILURE: 'ZONE_GET_FAILURE',

  GETALL_REQUEST: 'ZONE_GETALL_REQUEST',
  GETALL_SUCCESS: 'ZONE_GETALL_SUCCESS',
  GETALL_FAILURE: 'ZONE_GETALL_FAILURE',

  RESET: 'ZONE_RESET',
  SERVICE: 'ZONE_SERVICE',
};
